import { InjectionToken } from '@angular/core';

export const billingContactFormTranslations = {
  primaryContactLabel: 'app.pricing.billing_contact_form.primary_contact_label',
  primaryContactTooltip: 'app.pricing.billing_contact_form.primary_contact_tooltip',
  fullNameLabel: 'app.pricing.billing_contact_form.full_name_label',
  fullNamePlaceholder: 'app.pricing.billing_contact_form.full_name_placeholder',
  emailLabel: 'app.pricing.billing_contact_form.email_label',
  emailPlaceholder: 'app.pricing.billing_contact_form.email_placeholder',
  phoneLabel: 'app.pricing.billing_contact_form.phone_label',
  phonePlaceholder: 'app.pricing.billing_contact_form.phone_placeholder',
  invoiceEmailsLabel: 'app.pricing.billing_contact_form.invoice_emails_label',
  errorPhoneInvalid: 'app.common.errors.phone.invalid',
  errorPhoneLength: 'app.common.errors.phone.length',
};

export type BillingContactFormTranslations = typeof billingContactFormTranslations;

export const BillingContactFormTranslationsToken =
  new InjectionToken<BillingContactFormTranslations>('BillingContactFormTranslationsToken');
